import { memo, useState } from 'react';
import { Popover, Stack } from '@mui/material';
import { NamesOfColors, VerticalMenuIcon } from 'front-package-ui-kit';

import { PopoverButton } from '../PopoverButton';
import { controlsOrigin } from 'config';
import { Typography } from '../Typography/Typography';

import s from './TableControls.module.scss';

interface TableControlsPopoverButton {
  access?: boolean;
  text: string;
  color?: string;
  callback: () => void;
}

interface TableControlsProps {
  id: number | string;
  buttons: TableControlsPopoverButton[];
  color?: NamesOfColors;
  disabled?: boolean;
}

export const TableControls = memo(
  ({ id, buttons, color = NamesOfColors.grey60, disabled }: TableControlsProps) => {
    const [popover, setPopover] = useState<HTMLButtonElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
      setPopover(event.currentTarget);
    };

    const handleClose = () => {
      setPopover(null);
    };

    return (
      <>
        {buttons.length > 0 && (
          <>
            <button
              className={s.tableControls}
              aria-describedby={Boolean(popover) ? `popover-client-${id}` : undefined}
              type="button"
              onClick={handleClick}
              disabled={disabled || false}
            >
              <VerticalMenuIcon size={16} color={color} />
            </button>
            <Popover
              id={Boolean(popover) ? 'popover-user' : undefined}
              anchorEl={popover}
              open={Boolean(popover)}
              anchorOrigin={controlsOrigin}
              onClose={handleClose}
            >
              <Stack sx={{ minWidth: '220px', padding: '8px 0' }}>
                {buttons.map((button, index) =>
                  button.access !== false ? (
                    <PopoverButton
                      key={`popover-button-${index}`}
                      onClick={() => {
                        handleClose();
                        button.callback();
                      }}
                    >
                      <Typography
                        component="p"
                        fontSize="1rem"
                        sx={{ color: button.color || '#000000DE' }}
                      >
                        {button.text}
                      </Typography>
                    </PopoverButton>
                  ) : undefined
                )}
              </Stack>
            </Popover>
          </>
        )}
      </>
    );
  }
);
